/* eslint-disable no-restricted-globals */
import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { useStyles } from "./Styles";
import Header from "./Header";
import Footer from "./Footer";

const AUTH_PATHS = ["/signin", "/signup", "/forgot-password", "/linkedin"];

class Layout extends React.PureComponent {
  handleRouteBasedClassName = () => {
    //@ts-ignore
    const { location } = this.props;
    //@ts-ignore
    return location.pathname === "/" ? "home" : "inverse-Header";
  };

  render() {
    //@ts-ignore
    const { classes } = this.props;
    const isAuthPage = AUTH_PATHS.includes(location.pathname);

    return (
      <div className={`${classes.pageWrapper} ${this.handleRouteBasedClassName()}`}>
        <CssBaseline />
        <Header location={this.handleRouteBasedClassName()} />
        <main className={isAuthPage ? classes.content2 : classes.content}>
          {isAuthPage ? (
            this.props.children
          ) : (
            <div className={classes.pageCard}>
              {this.props.children}
            </div>
          )}
        </main>
        <Footer />
      </div>
    );
  }
}

//@ts-ignore
export default withRouter(withStyles(useStyles)(Layout));
